import React from 'react';

import { Container, Text, ImgRender } from './styles';

function Card({text , ImgSource, ImgSourceDesk}) {   


  return (
    <Container src = {ImgSourceDesk} >
      <ImgRender src = {ImgSource}/>
      <Text>{text}</Text>
    </Container>
  );
}

export default Card;